// Layout
const dashboardLayout = () => import('@/layouts/DashboardLayout/dashboardLayout.vue')

const setting = () => import('./views/index')

// start Routes
export default [
  {
    path: '/setting-store',
    name: 'storeSetting',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'storeSetting',
      meta: {
        name: 'storeSetting',
        parentName: 'marketplace',
        userType: '',
        permission: ''
      },
      component: setting
    }
    ]
  }
]
